/* eslint-disable no-bitwise */
export const isNodeFollowing = bitmask => bitmask & Node.DOCUMENT_POSITION_FOLLOWING;

export const isNodeArgsInDocumentOrder = (node1, node2) => {
    const bitmask = node1.compareDocumentPosition(node2);

    return isNodeFollowing(bitmask);
};
/* eslint-enable no-bitwise */
